import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Row, Col } from 'reactstrap';

const TooltipMenu = ({target, isOpen, options, toggle, styleTool}) => {
  return (
    <Tooltip className='opacity-100' autohide={false}
      innerClassName='bg-white text-black p-0 border rounded-sm' hideArrow
      target={target} placement='bottom-end' isOpen={isOpen} toggle={toggle}
      style={styleTool}>
      <div>
        {options.map((opt, i) =>
          <Row onMouseDown={ () => { if (opt.onClick && !opt.disabled) opt.onClick(); }} key={`${target}_opt_${i}`} className={'p-2 hover-light m-0'+ (opt.disabled ? ' bg-light text-light-blue' : ' clickable') + (opt.className ? ' '+ opt.className : '')}>
            <Col className='p-0'>{opt.label}</Col>
          </Row>
        )}
      </div>
    </Tooltip>
  )
};

TooltipMenu.propTypes = {
  target: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  toggle: PropTypes.func.isRequired
};

export default TooltipMenu;